import React, { Component, Fragment } from 'react'
import './ProductDetailMobile.scss'
import { get } from '../../utility/apiClient';
import { errorTypesEnum, showcaseDefaultsEnum, productListingTypeEnum } from '../../utility/enums';
import ShowcaseBestSellers from '../../components/showcaseBestSellers/ShowcaseBestSellers';
import NexusLogo from '../../assets/img/logo/Nexus.png'
import KeelsDealsLogo from '../../assets/img/logo/KeellsDeals.png'
import { ToastContainer, Flip, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { JKOAMerchantTypes, shoppingMethod } from '../../utility/enums';
import { Col, Row, Button, ButtonGroup, Accordion, Card, Table } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import Magnifier from "react-magnifier";

/*-- Import required components --*/
import { toCurrency, IncrementItem, DecrementItem } from '../../utility/commonFunctions';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';
import { updateResponsive, resetResponsive } from '../../redux/actions/responsiveActions';
import { addPromotionItems } from '../../redux/actions/promotionItemsActions';
import { showProductMagnifier } from '../../redux/actions/productMagnifierActions';
import { showAgeGate, resetAgeGate } from '../../redux/actions/ageGateActions';
import { showMessageBox, resetMessageBox } from '../../redux/actions/messageBoxActions';
import { jkoaPurchaseYes, jkoaPurchaseNo } from '../../redux/actions/jkoaPurchaseAction';
import HelmetMeta from '../../utility/HelmetMeta';
import { DefaulProductImage } from '../../utility/environment_config';
import { GtagEvent, ProductDetailEventGA4 } from '../../utility/googleAnalytics';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
        userDetails: state.userDetails,
        loadingScreenVisible: state.loadingScreen,
        shoppingPreferences: state.shoppingPreference,
        itemCart: state.itemCart,
        promotionItems: state.promotionItems,
        ageVerification: state.ageVerification,
        systemConfiguration: state.webDataCollection.systemConfiguration,
        shoppingPreference: state.shoppingPreference,
        jkoaPurchase: state.jkoaPurchase,
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    showMessageBox,
    showLoadingScreen,
    hideLoadingScreen,
    updateResponsive,
    resetResponsive,
    addPromotionItems,
    showProductMagnifier,
    showAgeGate,
    resetAgeGate,
    resetMessageBox,
    jkoaPurchaseYes,
    jkoaPurchaseNo
};

SwiperCore.use([Navigation, Pagination]);

class ProductDetailMobile extends Component {
    constructor(props) {
        super();
        this.state = {
            featuredProducts: [],
            bestSellers: [],
            brands: [],
            groups: [],
            summaryText: "",
            banners: [],
            headerBanner: "",
            isShowItemCardStyle: false,
            itemID: 0,
            stockInHand: 0,
            product: "",
            itemTopic: "",
            itemOwner: "",
            itemCode: "",
            itemPromotionDiscountValue: 0,
            itemMinQty: 1,
            itemAmount: 100,
            itemuom: 'NO',
            itemDes: "",
            isSponsored: false,
            isFeatured: false,
            isShowBrandPage: false,
            isOffer: false,
            subDepartmentCode: "",
            categoryCode: "",
            departmentCode: "",
            itemStockInHand: 100,
            itemAssets: [],
            itemTagsName: [],
            itemTagsID: [],
            slidesTransform: 0,
            mainImg: DefaulProductImage,
            offers: [],
            itemSpecification: [],
            itemLongDes: "",
            itemFullDes: "",
            ismoreDetails: false,
            isVisible: true,
            heightVal: 0,
            activeSlider: 0,
            url: []
        }
    }

    onScroll = () => {
        let heightToHideFrom = document.getElementById("FooterTitle").getBoundingClientRect().y;
        let screenHeight = window.screen.height;
        this.setState({ heightVal: screenHeight });
        if (screenHeight > heightToHideFrom) {
            this.state.isVisible && this.setState({ isVisible: false });
        } else {
            this.setState({ isVisible: true });
        }
    };

    componentDidMount() {
        this.loadData();
        window.addEventListener("scroll", this.onScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }

    incrementProduct(product) {
        IncrementItem(product, () => { })
    };

    addProduct(product) {
        //change to proper value
        if (product.checkAge) {
            //is of legal age
            if (this.props.ageVerification.isLegalAge && this.props.ageVerification.attemptedVerification) {
                IncrementItem(product, () => { })
                this.showNotificationBox()
            } else if (!this.props.ageVerification.isLegalAge && this.props.ageVerification.attemptedVerification) {
                this.showAgeFail();
            } else if (!this.props.ageVerification.attemptedVerification) {
                let ageGate = {
                    show: true,
                    isPage: false,
                    callBackFunction: (response) => {
                        if (response) {
                            this.props.resetAgeGate().then(() => { IncrementItem(product, () => { }) })
                            this.showNotificationBox()
                        } else {
                            this.props.resetAgeGate()
                            this.showAgeFail();
                        }
                    }
                }
                this.props.showAgeGate(ageGate);
            }
        } else {
            let curretIsJKOA = Object.values(JKOAMerchantTypes).includes(product.merchantID);
            if (this.props.itemCart.length > 0) {
                if ((this.props.jkoaPurchase && !curretIsJKOA) || (!this.props.jkoaPurchase && curretIsJKOA)) {
                    this.showJKOAItemFail();
                } else {
                    curretIsJKOA ? this.props.jkoaPurchaseYes() : this.props.jkoaPurchaseNo();
                    IncrementItem(product, () => { })
                    this.showNotificationBox()
                }
            } else {
                if (curretIsJKOA) {
                    if (this.props.shoppingPreference.shoppingMethod === shoppingMethod.delivery) {
                        this.props.jkoaPurchaseYes();
                        IncrementItem(product, () => { })
                        this.showNotificationBox()
                    } else {
                        this.showJKOAShippingMethodFail();
                    }
                } else {
                    IncrementItem(product, () => { })
                    this.showNotificationBox()
                }
            }
        }
    }

    showJKOAItemFail() {
        let messageBox = {
            show: true,
            title: "Information",
            className: "info",
            content: "Sorry. Can't puchase Electronic and Grocery items in a same cycle",
            isConfirmation: false,
            callBackFunction: null
        }
        this.props.showMessageBox(messageBox);
    };

    showJKOAShippingMethodFail() {
        let messageBox = {
            show: true,
            title: "Information",
            className: "info",
            content: "Sorry! The Click & Collect facility is not active for mobile phones and electronics at the moment. Please change your shipping method to ‘Delivery’ to continue shopping.",
            isConfirmation: false,
            callBackFunction: null
        }
        this.props.showMessageBox(messageBox);
    };

    decrementProduct(product) {
        DecrementItem(product, () => { })
    };

    showAgeFail() {
        let messageBox = {
            show: true,
            title: "Information",
            className: "info",
            content: "You must be " + this.props.systemConfiguration.legalAgeLimit + " years or older to purchase this product",
            isConfirmation: false,
            callBackFunction: null
        }
        this.props.showMessageBox(messageBox);
    }

    showNotificationBox() {
        if (!this.props.userDetails.isGuest) {
            toast(<div><i className="fas fa-shopping-cart"></i>{"Item successfully added to cart.!"}</div>);
        }
    };

    showAlertBox() {
        toast(<div><i className="far fa-copy"></i>{"Link Copied.!"}</div>);
    };

    changeImg(index) {
        this.setState({
            mainImg: this.state.itemAssets[index]
        });
    }

    magnifyProduct(data) {
        if (data) {
            let productMagnifier = {
                show: true,
                imageUrl: data
            }
            this.props.showProductMagnifier(productMagnifier);
        }
    }

    loadData() {
        this.props.showLoadingScreen();
        const { location: { search } } = this.props.product;
        const splitSearch = search.split("=").join(",").split("&").join(",").split(",");
        let locationCode = this.props.shoppingPreferences.outletCode ? this.props.shoppingPreferences.outletCode : showcaseDefaultsEnum.locationCode
        if (locationCode === '') {
            locationCode = 'SCDR';  //live common location with liquor
        }
        get("/Web/GetProductDetails?itemCode=" + splitSearch[1] + "&locationCode=" + locationCode).then(response => {
            if (response.data.statusCode == 200) {
                if (response.data.result) {
                    if (response.data.result.itemDetail) {
                        let data = response.data.result.itemDetail;
                        // GtagEvent({ action: 'productdetail', category: 'product', label: 'Product Details' });
                        ProductDetailEventGA4(data)
                        let tags = [data.departmentCode, data.subDepartmentCode, data.categoryCode];
                        this.setState({
                            product: data,
                            itemTopic: data.name,
                            itemDes: data.longDescription,
                            itemCode: data.itemCode,
                            itemAmount: data.amount,
                            itemMinQty: data.minQty,
                            itemuom: data.uom,
                            itemPromotionDiscountValue: data.promotionDiscountValue,
                            stockInHand: data.stockInHand,
                            subDepartmentCode: data.subDepartmentCode,
                            departmentCode: data.departmentCode,
                            categoryCode: data.categoryCode,
                            itemID: data.itemID,
                            isSponsored: data.isSponsored,
                            isFeatured: data.isFeatured,
                            offers: response.data.result.itemOfferDetailList,
                            itemFullDes: data.detailDescription
                        }, () => {
                            this.props.hideLoadingScreen();
                            this.shortDescription();
                        })
                    } else {
                        let errorType = response.data.errorList[0].errorType;
                        let messageBox = {
                            show: true,
                            title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                            className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                            content: response.data.errorList[0].statusMessage,
                            isConfirmation: false,
                            callBackFunction: (response) => {
                                window.location.href = `/`;
                            }
                        }
                        this.props.hideLoadingScreen();
                        this.props.showMessageBox(messageBox);
                    }
                    if (response.data.result.itemOfferDetailList.length > 0) {
                        let offer = response.data.result.itemOfferDetailList
                        this.setState({
                            offers: offer,
                            isOffer: true
                        }, () => {
                            this.props.hideLoadingScreen();
                        })
                    }
                    if (response.data.result.brandDetail) {
                        let brandDetail = response.data.result.brandDetail
                        this.setState({
                            itemOwner: brandDetail.brandName,
                            isShowBrandPage: brandDetail.isShowBrandPage
                        }, () => {
                            this.props.hideLoadingScreen();
                        })
                    }
                    if (response.data.result.categoryDetail) {
                        let tagNames = [response.data.result.categoryDetail.departmentName, response.data.result.categoryDetail.subDepartmentName, response.data.result.categoryDetail.categoryName]
                        let tagsIDs = [response.data.result.categoryDetail.departmentID, response.data.result.categoryDetail.subDepartmentID, response.data.result.categoryDetail.categoryID]
                        let tagurls = [response.data.result.categoryDetail.departmentURL,response.data.result.categoryDetail.subDepartmentURL]
                        this.setState({
                            itemTagsName: tagNames,
                            itemTagsID: tagsIDs,
                            url: tagurls
                        }, () => {
                            this.props.hideLoadingScreen();
                        })
                    }
                    if (response.data.result.itemSpecificationList.length > 0) {
                        this.setState({
                            itemSpecification: response.data.result.itemSpecificationList,
                            itemDetail: true
                        }, () => {
                            this.props.hideLoadingScreen();
                        })
                    }
                    if (response.data.result.assetList.length > 0) {
                        this.setState({
                            itemAssets: response.data.result.assetList,
                            mainImg: response.data.result.assetList[0],
                        }, () => {
                            this.props.hideLoadingScreen();
                        })
                    }
                }
            } else {
                let errorType = response.data.errorList[0].errorType;
                let messageBox = {
                    show: true,
                    title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                    className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                    content: response.data.errorList[0].statusMessage,
                    isConfirmation: false,
                    callBackFunction: (response) => {
                        window.location.href = `/`;
                    }
                }
                this.props.hideLoadingScreen();
                this.props.showMessageBox(messageBox);
            }
        })
    }
    longDescription() {
        this.setState({ itemLongDes: this.state.itemFullDes, ismoreDetails: false });
    }
    shortDescription() {
        var shortDetailDescription = this.state.itemFullDes.substring(200, this.state.itemFullDes);

        this.setState({ itemLongDes: shortDetailDescription, ismoreDetails: true });
    }

    ChangeAccordion(selectedAccordion) {
        if (this.state.selectedAccordion === selectedAccordion) { selectedAccordion = ''; }
        this.setState({ selectedAccordion })
    }

    gotoDepartment(checkAge, data) {
        if (checkAge) {
            if (this.props.ageVerification.isLegalAge && this.props.ageVerification.attemptedVerification) {
                window.location.href = data;
            } else if (!this.props.ageVerification.isLegalAge && this.props.ageVerification.attemptedVerification) {
                this.showAgeFail();
            } else if (!this.props.ageVerification.attemptedVerification) {
                let ageGate = {
                    show: true,
                    isPage: true,
                    callBackFunction: (response) => {
                        if (response) {
                            this.props.resetAgeGate().then(() => { window.location.href = data; })
                        } else {
                            this.props.resetAgeGate()
                            this.showAgeFail();
                        }
                    }
                }
                this.props.showAgeGate(ageGate);
            }
        } else {
            window.location.href = data;
        }
    }

    copyCodeToClipboard = (e) => {
        const text = this.textArea;
        const path = window.location.href.split('//');
        const baseUrl = path[1].split('/');
        let url = '';
        let itemUrl = `${this.state.itemCode}%26${this.state.itemTopic.replace(/ /g, "_")}`
        let copyLink = `${this.state.itemCode}&${this.state.itemTopic.replace(/ /g, "_")}`
        if (e === 'facebook') {
            url = `https://www.facebook.com/sharer.php?u=http%3A%2F%2F${baseUrl[0]}%2FproductDetail%3Fitemcode%3D${itemUrl}`;
            window.open(url);
        }
        if (e === 'twitter') {
            url = `https://twitter.com/intent/tweet?url=http%3A%2F%2F${baseUrl[0]}%2FproductDetail%3Fitemcode%3D${itemUrl}`;
            window.open(url);
        }
        if (e === 'link') {
            url = `http://${baseUrl[0]}/productDetail?itemcode=${copyLink}`;
            this.showAlertBox();
        }
        text.value = url;
        text.select();
        document.execCommand("copy");

    }

    render() {
        const itemPromotion = this.props.promotionItems.find(x => x.itemID === this.state.itemID);
        const slides = this.state.itemAssets.map((tag, index) =>
            <SwiperSlide key={`slide-${tag}`}
                className={
                    this.state.activeSlider === index ? `product-card-container limitile activeSlider` : `product-card-container limitile inactiveSlider`
                }
            >
                <img className="limitileImg"
                    onClick={
                        () => {
                            this.changeImg.call(this, index);
                            this.setState({ activeSlider: index });
                            index === 0 && document.body.classList.remove("activeSlider");
                        }
                    }
                    src={`${tag}`}
                    alt={`Slide ${tag}`}
                    onError={(e) => { e.target.onerror = null; e.target.src = DefaulProductImage }}
                />
            </SwiperSlide>
        );
        const offers = this.state.offers === [] ? null : this.state.offers.map((offer, index) =>
            <Card style={{ borderStyle: "none", borderRadius: "0rem 1.5625rem", padding: "3px" }}>
                <Accordion.Toggle style={{ padding: "5px", borderStyle: "none", borderColor: "#C7F7A0", backgroundColor: "#C7F7A0", color: "gray" }} class="d-flex justify-content-between" onClick={this.ChangeAccordion.bind(this, `${index}`)} as={Card.Header} eventKey={`${index}`} align="left">
                    <span className='faq-headers-text' align="left">{offer.description}</span>
                    <i class={`fas fa-${this.state.selectedAccordion === `${index}` ? 'chevron-right' : 'chevron-down'}`} align="right"></i>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={`${index}`}>
                    <Card.Body style={{ backgroundColor: "#C7F7A0" }}>
                        {offer.conditions.map((con) =>
                            <span style={{ whiteSpace: "nowrap", backgroundColor: "#C7F7A0", color: "#0084BC" }}><i class="fas fa-circle" style={{ fontSize: "0.5rem", paddingRight: "0.5rem" }}></i> {con}</span>
                        )}
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        );
        console.log("fuckasdadad");
        console.log(this.state.itemSpecification);
        const specBody = this.state.itemSpecification.length === 0 ? null : this.state.itemSpecification.map((spec) =>
            <tr>
                <th>{spec.specificationHeader}</th>
                <td>{spec.specificationDetail}</td>
            </tr>
        );
        const productDetails = (<Card style={{ borderStyle: "none" }}>
            <Accordion.Toggle style={{ padding: "5px", borderStyle: "none" }} class="d-flex justify-content-between" onClick={this.ChangeAccordion.bind(this, `1`)} as={Card.Header} eventKey={`1`} align="left">
                <span className='faq-headers-text' align="left">Product Details</span>
                <i class={`fas fa-${this.state.selectedAccordion === `1` ? 'chevron-right' : 'chevron-down'}`} align="right"></i>
            </Accordion.Toggle>

            <Accordion.Collapse eventKey={`1`}>
                <Card.Body style={{}}>
                    <Table>
                        {specBody}
                    </Table>
                </Card.Body>
            </Accordion.Collapse>
        </Card>);

        return (
            <React.Fragment>
                <HelmetMeta val={this.state.mainImg} title={this.state.itemTopic} />
                <Col style={{ paddingBottom: "50px" }}></Col>
                <Row >
                    <Col md="6">
                        <Row className="d-flex justify-content-center">
                            <span className="productName text-center" style={{ fontSize: "2rem" }}>{this.state.itemTopic}</span>
                        </Row>
                        <Row className="d-flex justify-content-center">
                            {this.state.isShowBrandPage ? <Col className="product-card-final-price btn"><span style={{ color: "black" }}>By</span> <span className="" onClick={this.gotoDepartment.bind(this, false, `/product?cat=${productListingTypeEnum.listAllBrand}&s=~${this.state.itemOwner}`)}>{this.state.itemOwner}</span></Col> : null}
                        </Row>
                        <Row className="d-flex justify-content-center">
                            <div style={{ paddingtop: "30px" }}>
                                <span className="">Keells #{this.state.itemCode}</span>
                            </div>
                        </Row>
                        <Row className="d-flex justify-content-center">
                            <div className="product-card-container limitMainTileMobile" style={{ borderStyle: "solid", borderColor: "#64BF47" }}>
                                <img className="img-fluid"
                                    src={this.state.mainImg}
                                    onError={(e) => { e.target.onerror = null; e.target.src = DefaulProductImage }}></img>
                                {this.state.isOffer ? <div className="product-detail-offer-badge-mobile">
                                    <div className="product-card-promotion-badge-single-line">
                                        <div className="product-detail-offer-badge-percentage-mobile">
                                            Offer
                                        </div>

                                    </div>
                                </div> : null}
                                {itemPromotion && !itemPromotion.checkPaymentMode ?
                                    <div className="product-card-promotion-badge-mobile" style={{ left: "70%", top: "83%" }}>
                                        {itemPromotion.otherPromotionTypeID === 2 ? <div className="product-card-promotion-badge-nexus"><img className="img-fluid" src={NexusLogo}></img></div> : <div className="product-card-promotion-badge-nexus"><img className="img-fluid" src={KeelsDealsLogo}></img></div>}
                                        <div className="product-card-promotion-badge-single-line">
                                            <div className="product-card-promotion-badge-percentage">
                                                {itemPromotion.discountPercentage}
                                            </div>
                                            <div>
                                                <div className="product-card-promotion-badge-suffix">%</div>
                                                <div className="product-card-promotion-badge-suffix">Off</div>
                                            </div>
                                        </div>
                                    </div>
                                    : null}

                                {this.state.isFeatured ?
                                    <div className="product-detail-feature-flag-mobile">
                                        <div className="product-card-promotion-badge-single-line">
                                            <div className="product-detail-feature-flag-percentage-mobile">
                                                Featured
                                            </div>

                                        </div>
                                    </div> : null}
                            </div>
                        </Row>

                    </Col>
                    <Col md="6">
                        <Row className="d-flex justify-content-center" style={{ paddingBottom: "10px" }}>
                            <div className="limitContainer" style={{ overflowY: "hidden" }}>
                                <Swiper
                                    tag="section"
                                    id="main"
                                    className=""
                                    spaceBetween={10}
                                    slidesPerView={"auto"}
                                    style={{ width: "100%", height: "100%" }}
                                >
                                    {slides}
                                </Swiper>
                            </div>
                        </Row>
                    </Col>
                    {
                        this.state.offers.length === 0 ? null :
                            <Col md="6" style={{ paddingLeft: "50px" }}>
                                <Row className="d-flex justify-content-center offerDetailMobile">
                                    <Accordion style={{ maxWidth: "115%" }}>
                                        {offers}
                                    </Accordion>
                                </Row>
                            </Col>
                    }

                    <Col md="6">
                        <Row className="d-flex justify-content-center">
                        <div>
                                {this.state.itemPromotionDiscountValue > 0 && itemPromotion && !itemPromotion.checkPaymentMode? <span className="product-card-original-price">{"Rs " + toCurrency(this.state.itemAmount)}</span> : null}
                                {itemPromotion && !itemPromotion.checkPaymentMode? <span className="product-card-final-price" style={{ fontSize: "2rem" }}>{"Rs " + toCurrency(this.state.itemAmount - this.state.itemPromotionDiscountValue) + " / " + (this.state.itemuom === "NO" ? "Unit" : this.state.product.uom)}</span> : <span className="product-card-final-price" style={{ fontSize: "2rem" }}>{"Rs " + toCurrency(this.state.itemAmount)}</span>}
                            </div>
                        </Row>
                        <Col md="6"
                            style={{ paddingBottom: "10px" }}>
                            {this.state.itemLongDes}
                            {this.state.itemFullDes.length > 200 && this.state.ismoreDetails === true && (
                                <>
                                    {'...'}
                                    <span className="longDescription"
                                        onClick={() => { this.longDescription(); }}
                                        id="morelong">
                                        See More
                                    </span>
                                </>
                            )
                            }

                            {this.state.ismoreDetails === false && (
                                <Fragment>
                                    <br />
                                    <span className="shortDescription"
                                        onClick={() => { this.shortDescription(); }}
                                        id="moreshort">
                                        See Less
                                    </span>
                                </Fragment>
                            )
                            }
                        </Col>
                        <Row className="d-flex justify-content-center">
                            {/* <Col className={
                                this.state.isVisible === true ? `limitBtnMobile removedClassFromState` : `limitBtnMobile addedClassFromState`
                            }>
                                {this.props.itemCart.find(x => x.itemID === this.state.itemID) ? <ButtonGroup className="product-card-button-quantity-selector w-100 ">
                                    <Button className="product-card-button-quantity-decrementor" onClick={this.decrementProduct.bind(this, this.state.product)}><i className="fas fa-minus"></i></Button>
                                    <Button className="product-card-button-quantity-display">{this.props.itemCart.find(x => x.itemID === this.state.itemID).quantity}</Button>
                                    <Button className="product-card-button-quantity-incrementor" onClick={this.incrementProduct.bind(this, this.state.product)}><i className="fas fa-plus"></i></Button>
                                </ButtonGroup>
                                    :
                                    this.state.stockInHand === 0 || this.state.stockInHand < this.state.itemMinQty ?
                                        <Button block className="product-card-button-add" id="add_to_cartId" disabled={true} >Out of Stock</Button>
                                        :
                                        <Button block className="product-Detail-button-add" onClick={() => { this.addProduct(this.state.product) }}><i className="fas fa-shopping-cart"></i>Add to Cart</Button>}
                            </Col> */}
                            <Col className="limitBtn" style={{ paddingBottom: "10px" }} >
                                {this.props.itemCart.find(x => x.itemID === this.state.itemID) ? <ButtonGroup className="product-card-button-quantity-selector w-100 ">
                                    <Button className="product-card-button-quantity-decrementor" onClick={this.decrementProduct.bind(this, this.state.product)}><i className="fas fa-minus"></i></Button>
                                    <Button className="product-card-button-quantity-display">{this.props.itemCart.find(x => x.itemID === this.state.itemID).quantity}</Button>
                                    <Button className="product-card-button-quantity-incrementor" onClick={this.incrementProduct.bind(this, this.state.product)}><i className="fas fa-plus"></i></Button>
                                </ButtonGroup>
                                    :
                                    this.state.stockInHand === 0 || this.state.stockInHand < this.state.itemMinQty ?
                                        <Button block className="product-card-button-add" id="add_to_cartId" disabled={true} >Out of Stock</Button>
                                        :
                                        <Button block className="product-card-button-add" onClick={() => { this.addProduct(this.state.product) }}><i className="fas fa-shopping-cart"></i>Add to Cart</Button>}
                            </Col>
                        </Row>
                        <Row className="d-flex justify-content-center">
                            <div>
                                <span>
                                    Tags
                                </span>
                                <span className="product-card-final-price" >
                                    <a key={this.state.itemTagsID[0]} onClick={this.gotoDepartment.bind(this, false, `/${this.state.url[0]}`)}> {this.state.itemTagsName[0]}, </a>
                                </span>
                                <span className="product-card-final-price" >
                                    <a style={{ padding: "5px" }} className="product-card-final-price" key={this.state.itemTagsID[1]} onClick={this.gotoDepartment.bind(this, false, `/${this.state.url[1]}`)}> {this.state.itemTagsName[1]}</a>
                                </span>
                            </div>
                        </Row>
                        <Row className="d-flex justify-content-center">
                            <div>
                                <span>
                                    Share:
                                </span>
                                <span className="btn" onClick={() => this.copyCodeToClipboard('facebook')}>
                                    <i class="fab fa-facebook"> </i>
                                </span>
                                <span className="btn" onClick={() => this.copyCodeToClipboard('twitter')}>
                                    <i class="fab fa-twitter"> </i>
                                </span>
                                <span className="btn" onClick={() => this.copyCodeToClipboard('link')}>
                                    <i class="fas fa-link"></i>
                                </span>
                                <div className="hideclip">
                                    <textarea
                                        ref={(textarea) => this.textArea = textarea}
                                        value=""
                                    />
                                </div>
                            </div>
                        </Row>
                        {
                            this.state.itemSpecification.length === 0 ? null :
                                <Col md="6" style={{ paddingLeft: "65px", paddingBottom: "5%" }}>
                                    <Row className="d-flex justify-content-center DetailMobile">
                                        <Accordion style={{ width: "95%" }}>
                                            {productDetails}
                                        </Accordion>
                                    </Row>
                                </Col>
                        }
                    </Col>
                </Row>
                <ToastContainer position="top-right" autoClose={1500} hideProgressBar newestOnTop closeOnClick rtl={false}
                    pauseOnVisibilityChange draggable pauseOnHover={false} transition={Flip} />
            </React.Fragment >
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailMobile);